export class SalesManager {
    userId: number;
    email: string;
    lastNm: string;
    firstNm: string;
    mobile: string;
  
    public get fullName(): string {
      return this.lastNm + this.firstNm;
    }
  
    constructor(obj?: any) {
      if (!obj) {
        return;
      }
      this.userId = obj.userId;
      this.email = obj.email;
      this.lastNm = obj.lastNm;
      this.firstNm = obj.firstNm;
      this.mobile = obj.mobile;
    }
  
  }


// WEBPACK FOOTER //
// ./src/app/services/sales/model/SalesManager.ts